import React, { useEffect, useState } from "react";
import { IOrderArchive } from "../../types/archiveOrders.type";
import dayjs from "dayjs";
import { DatePicker, message, Table, Typography } from "antd";
import { api } from "../../api/api";

const { Title } = Typography;
const { RangePicker } = DatePicker;

export default function ArchiveOrders() {
  const [orders, setOrders] = useState<IOrderArchive[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);
  const [total, setTotal] = useState<number>(0);
  const [dateRange, setDateRange] = useState<
    [dayjs.Dayjs, dayjs.Dayjs] | undefined
  >([dayjs().startOf("month"), dayjs().endOf("month")]);

  const handleRangeChange = (dates: any) => {
    if (dates) {
      setDateRange([dates[0], dates[1]]);
    } else {
      setDateRange(undefined);
    }
  };

  const fetchOrders = async () => {
    setLoading(true);

    try {
      const response = await api.get("/archive/orders", {
        params: {
          page,
          limit: pageSize,
          startDate: dateRange ? dateRange[0]?.format("DD.MM.YY") : undefined,
          endDate: dateRange ? dateRange[1]?.format("DD.MM.YY") : undefined,
        },
      });
      setOrders(response.data.orders);
      setTotal(response.data.total);
    } catch (error) {
      console.error("Error fetching orders", error);
      message.error("Ошибка при получение заказов");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [page, pageSize, dateRange]);

  const columns = [
    {
      title: "Дата создания",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Дата удаления",
      dataIndex: "dateRemoved",
      key: "dateRemoved",
    },
    {
      title: "Удалил",
      dataIndex: "removedBy",
      key: "removedBy",
    },
    {
      title: "Имя клиента",
      dataIndex: "clientName",
      key: "clientName",
    },
    {
      title: "Тип",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Тип сущ.",
      dataIndex: "kind",
      key: "kind",
    },
    {
      title: "Имя",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Ед. измерения",
      dataIndex: "unitOfMeasurement",
      key: "unitOfMeasurement",
    },
    {
      title: "Валюта",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Курс",
      dataIndex: "exchangeRate",
      key: "exchangeRate",
    },
    {
      title: "Скидка",
      dataIndex: "discount",
      key: "discount",
      render: (discount: number) => `${discount}%`,
    },
    {
      title: "Цена в USD",
      key: "price",
      render: (_: any, order: IOrderArchive) => order.price.USD,
    },
    {
      title: "Цена в TJS",
      key: "price",
      render: (_: any, order: IOrderArchive) => order.price.TJS,
    },
    {
      title: "Остаток до",
      dataIndex: "residueBefore",
      key: "residueBefore",
    },
    {
      title: "Остаток после",
      dataIndex: "residueAfter",
      key: "residueAfter",
    },
    {
      title: "Кол-во",
      dataIndex: "total",
      key: "total",
    },
    {
      title: "Возврат",
      dataIndex: "returned",
      key: "returned",
    },
    {
      title: "Сумма в USD",
      key: "totalCost",
      render: (_: any, order: IOrderArchive) => order.totalCost.USD,
    },
    {
      title: "Сумма в TJS",
      key: "totalCost",
      render: (_: any, order: IOrderArchive) => order.totalCost.TJS,
    },
    {
      title: "Статус",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Профит в USD",
      key: "profit",
      render: (_: any, order: IOrderArchive) => order.profit.USD,
    },
    {
      title: "Профит в TJS",
      key: "profit",
      render: (_: any, order: IOrderArchive) => order.profit.TJS,
    },
    {
      title: "Создал",
      dataIndex: "ownerName",
      key: "ownerName",
    },
  ];
  return (
    <div style={{ padding: 24 }}>
      <Title>Архив Заказов</Title>
      <RangePicker
        onChange={handleRangeChange}
        placeholder={["Начало", "Конец"]}
        format="DD.MM.YY"
        value={dateRange}
      />

      <Table
        columns={columns}
        dataSource={orders}
        rowKey={(record) => record._id}
        pagination={{
          current: page,
          total: total,
          pageSize: pageSize,
          onChange: (page, size) => {
            setPage(page);
            if (size !== pageSize) setPageSize(size!);
          },
          showSizeChanger: true,
        }}
        scroll={{ x: "max-content" }}
        loading={loading}
      />
    </div>
  );
}
